import React from "react";
import avtlogo from "../../img/truck.png";

const MyMarker = ({ text, tooltip, $hover }) => {
  
  const handleClick = () => 
  {
    const tooltipContent =
    '<div id="content">' +     
    "<button id='historyButton' ><span id='hlogo'> <i class='fas fa-history'></i></span> View History</button>"+
    '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'+"<button id='ShareButton' ><span id='hlogo'> <i class='fa fa-share-alt'></i></span></button>"+
    "</div>";
    
    
  };
 
  return (
  <>
    <div   title={tooltip} data-id={text} className={$hover ? "circle hover" : "circle"} onClick={handleClick}>
   
   
    </div>
    
    <div class='pulse'></div>
    </>
  );
};
//{text}
export default MyMarker;
